import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useRestaurant } from "../../contexts/RestaurantContext";
import { selectRestaurantData, selectCompanySettings } from "../../app/restaurantSlice";
import {
  isOnlineOrderingAllowed,
  isReservationAllowed,
} from "../../utils/companyFeatureFlags";

/**
 * Redirects to restaurant home when a Super Admin feature flag is off.
 * @param {"onlineOrdering"|"reservation"} feature
 */
export default function CompanyFeatureGate({ feature, children }) {
  const { restaurantSlug } = useRestaurant();
  const location = useLocation();
  const restaurantData = useSelector((state) =>
    restaurantSlug ? selectRestaurantData(state, restaurantSlug) : null
  );
  const companySettings = useSelector((state) =>
    restaurantSlug ? selectCompanySettings(state, restaurantSlug) : null
  );

  // Wait for bootstrap; parent Content already gates Outlet on chromeReady.
  if (!restaurantSlug || !restaurantData) {
    return children ?? null;
  }

  const allowed =
    feature === "reservation"
      ? isReservationAllowed(restaurantData, companySettings)
      : isOnlineOrderingAllowed(restaurantData, companySettings);

  if (!allowed) {
    return (
      <Navigate
        to={`/${restaurantSlug}/home`}
        replace
        state={{ from: location.pathname, featureBlocked: feature }}
      />
    );
  }

  return children ?? null;
}
